export const RESET_CONFIG_STATE = "RESET_CONFIG_STATE";

export const ADD_NEW_NOTIFICATION = "ADD_NEW_NOTIFICATION";
export const CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION";
